import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from '../../shared/shared.module';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { SubscriptionsComponent } from './subscriptions.component';
import { SubscriptionsListModule } from './subscriptions-list/subscriptions-list.module';

@NgModule({
    imports: [
      CommonModule,
      BrowserModule,
      NgbModule,
      SharedModule,
      BsDatepickerModule,
      SubscriptionsListModule
    ],
    declarations: [SubscriptionsComponent],
    exports: [SubscriptionsComponent],
    entryComponents: []
  })
  export class SubscriptionsModule {}
